import React from "react";
import { Link } from "react-router-dom";
import FinancingBanner from "@/components/FinancingBanner";
import SocialLinks from "@/components/SocialLinks";
import { trackEvent } from "@/lib/analytics";
import { reviewUrl } from "@/data/social";

export default function SiteFooter() {
  return (
    <>
      <div className="financing-mobile-slot">
        <div className="container">
          <FinancingBanner variant="cta" />
        </div>
      </div>

      <footer className="site-footer">
        <div className="container">
          <div className="footer-flex">
            <div>
              <h2>Auto Basic Care</h2>
              <p style={{ color: "#a1a1aa", marginTop: 8 }}>1700 31st Street SW, Birmingham, AL 35221</p>
              <p style={{ color: "#a1a1aa", marginTop: 4 }}>Mon–Sat 8:00 AM – 4:30 PM · Closed Sunday</p>
              <p style={{ color: "#a1a1aa", marginTop: 4, fontStyle: "italic" }}>Good Prices. Good Name. Reliable Service.</p>
            </div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <a href="tel:2054051238" className="btn btn-primary" data-testid="footer-call-btn" onClick={() => trackEvent("Contact", { source: "footer" })}>Call 205-405-1238</a>
              <a href={reviewUrl} target="_blank" rel="noopener noreferrer" className="btn btn-dark" data-testid="footer-review-btn" onClick={() => trackEvent("Lead", { content_type: "review", source: "footer" })}>★ Leave a Google Review</a>
            </div>
          </div>

          <div className="footer-social-wrap">
            <span className="footer-social-tag">Connect with us:</span>
            <SocialLinks variant="icons" size="md" />
          </div>

          <nav className="footer-nav" aria-label="Footer">
            <Link to="/" data-testid="footer-nav-home">Home</Link>
            <Link to="/specials" data-testid="footer-nav-specials">Specials</Link>
            <Link to="/tires" data-testid="footer-nav-tires">Tires</Link>
            <Link to="/financing" data-testid="footer-nav-financing">Financing</Link>
            <Link to="/news" data-testid="footer-nav-news">News</Link>
            <Link to="/faq" data-testid="footer-nav-faq">FAQ</Link>
            <a href="/#schedule" data-testid="footer-nav-schedule">Schedule</a>
          </nav>
        </div>
      </footer>
    </>
  );
}
